import React, { Component } from 'react';
import {getActiveUsersForAdmin} from "../../util/ApiUtils";
import {Route} from "react-router-dom";
import {ACCESS_TOKEN, V1_API_URL_PREFIX} from "../../Constants";
import {NotificationManager} from "react-notifications";

class AdminResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileNames: [],
            message: null
        };
        this.getEmailAccounts = this.getEmailAccounts.bind(this);
    }


    componentDidMount() {
        this.getEmailAccounts();
    }

    getEmailAccounts() {
        this.setState({
            isLoading: true
        });
        getActiveUsersForAdmin()
            .then(response => {
                console.log('response', response);
                this.setState({
                    userAccounts: response,
                    isLoading: false
                });
            }).catch(error => {
            console.log('error', error);
            this.setState({
                isLoading: false
            });
        });
    }

    submit() {
        let email = document.getElementById("email");
        let newPassword = document.getElementById("newPassword");
        if (
            email && email.value !== '' ||
            newPassword && newPassword.value !== ''
        ) {
            const headers = new Headers({
                'Content-Type': 'application/json',
            });

            if (localStorage.getItem(ACCESS_TOKEN)) {
                headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
            }

            const defaults = {headers: headers};
            let options = Object.assign({}, defaults, {
                url: V1_API_URL_PREFIX + "/admin/reset-client-password",
                method: 'POST',
                body: JSON.stringify({ email: email.value, newPassword: newPassword.value })
            });
            return fetch(options.url, options)
                .then(response => {
                        if (response.status !== 200) {
                            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
                            return Promise.reject();
                        }
                        document.getElementById("email").value = "";
                        document.getElementById("newPassword").value = "";
                        NotificationManager.success('Success', 'The new password has ben set.', 5000);
                        return Promise.resolve();
                    }
                );
        } else {
            console.log("invalid");
            NotificationManager.error('Error', 'Please enter all required fields', 5000);
        }
    }

    render() {
        return (
            <Route path={`/admin/reset-client-password` }>
            <div className="container" style={{ textAlign: "center" }}>
                <h3>Delete A Client</h3>
                <div className="container">
                    <table className="table" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <tbody style={{ textAlign: "right"}}>
                        <tr>
                            <td>User Email Address <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="email" id="email"/></td>
                        </tr>
                        <tr>
                            <td>New Password <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="newPassword" id="newPassword"/></td>
                        </tr>
                        <tr style={{ textAlign: "left"}}>
                            <td></td>
                            <td><button type="submit" onClick={ this.submit }>RESET PASSWORD</button></td>
                        </tr>
                        </tbody>
                    </table>
                    <span>List of existing user accounts</span>
                    {this.state.userAccounts && this.state.userAccounts.map(function(item) {
                        console.log('item', item);
                        return <React.Fragment><span id={item.email}>{item.email} ({item.account.name})</span><br/></React.Fragment>;
                    })}
                </div>
            </div>
            </Route>
        )
    }
}

export default AdminResetPassword;